import {
  createFileRoute,
  useParams,
  Outlet,
  useLocation,
} from "@tanstack/react-router"
import { checkPermissions } from "@/utils/checkPermissions"
import {
  LayoutWithSidebar,
  DetailSidebar,
  useLayoutConfig,
} from "toptaal-shared"
import ScreenWrapper from "@/components/ScreenWrapper"
import { useLaptopQuery } from "@/api/queries/laptops/useLaptopQuery"

export const Route = createFileRoute("/beheer/laptops/$laptopId")({
  component: Parent,
  beforeLoad: () => checkPermissions("read", "laptops"),
})

function Parent() {
  const { pathname } = useLocation()
  const layoutConfig = useLayoutConfig()

  const { laptopId } = useParams({
    from: "/beheer/laptops/$laptopId",
  })
  const { data: laptop } = useLaptopQuery({ laptopId: Number(laptopId) })

  const base = `/beheer/laptops/${laptopId}`

  const sidebarNavigationItems = [
    {
      label: "Leengeschiedenis",
      to: `${base}/leengeschiedenis`,
    },
  ]

  return (
    <ScreenWrapper className="!px-0">
      <LayoutWithSidebar
        rightPanelClassName={layoutConfig.rightPanelClassName}
        sidebar={
          <DetailSidebar
            items={sidebarNavigationItems}
            isItemActive={(route: string) => pathname.startsWith(route)}
            goBackLabel="Laptops"
            goBackRoute="/beheer/laptops"
          >
            <div className="bg-white rounded p-4 mb-8">
              <h2 className="text-xl">{laptop?.serialNumber}</h2>
              <p>{laptop?.brand}</p>
              {laptop?.type && (
                <p className="text-sm text-gray-500">{laptop.type}</p>
              )}
            </div>
          </DetailSidebar>
        }
      >
        <Outlet />
      </LayoutWithSidebar>
    </ScreenWrapper>
  )
}
